import React, { useContext } from 'react';
import { createUserWithEmailAndPassword, getAuth, 
        signInWithEmailAndPassword, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { createUser, getUserByUID } from '../services/userService';
import { getLeaguesByUID } from '../services/leagueService';
import theme from '../theme/theme';
import { Avatar, Button, CircularProgress, Grid, IconButton, InputAdornment, 
         TextField, Typography } from "@mui/material";
import { globalStore } from '../state/store';
import { CircularProgressCP } from '../components';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faKey, faEnvelope } from '@fortawesome/free-solid-svg-icons';

import google from '../assets/img/icon_google.png'
import facebook from '../assets/img/icon_fb.png'
import apple from '../assets/img/icon_apple.png'
import { getPredictionByUID, getPredictionAnswer } from '../services/predictionService';

export default function SignInUp(props) {

    const styles = {
        hiddenBox: {
          display: 'none',
        },
        resizeBox: { 
          [theme.breakpoints.only('xs')]: { width: '320px' },
          [theme.breakpoints.up('sm')]: { width: '480px' },
          marginBottom: '20px',
        },
        avIcon: {
          backgroundColor: 'transparent',
          borderRadius: '0px',
          width: '22px',
          height: '22px',
          margin: '3px 13px 3px 3px',
        },
        avIconApple: {
          backgroundColor: 'transparent',
          borderRadius: '0px',
          width: '22px',
          height: '25px',
          margin: '3px 15px 3px 3px',
        },
        signinChip: {
          padding: '13px 2px',
          margin: '0px 0px 2px 3px',
          borderRadius: '3px',
          //border: '1px solid' + theme.palette.grey[300],
          border: '1px solid' + theme.palette.primary.contrastText,
          '&:hover': {
            backgroundColor: theme.palette.grey[200],
            //border: '1px solid' + theme.palette.primary.main,
            cursor: 'pointer',
          }
        }
    }

    const navigate = useNavigate();
    const auth = getAuth();
    const providerGoogle = new GoogleAuthProvider();
    const [state, dispatch] = useContext(globalStore);
  
    const [showPassword, setShowPassword] = React.useState(false)
    //const [settingPassword, setSettingPassword] = React.useState( // If the createstring is defined, default to Step 1
      //createstring !== undefined && createstring !== null && createstring.length === 20 ? "step1" : null)
    const [settingPassword, setSettingPassword] = React.useState(null)
    const [forgotPassword, setForgotPassword] = React.useState(false)
    const [signingUp, setSigningUp] = React.useState(false)
    const [email, setEmail] = React.useState({valid: false, value: ''});
    const [password, setPassword] = React.useState({valid: false, value: ''});
    const [loading, setLoading] = React.useState(false);

    let path = ['create'].includes(props.variant) ? 
            '/league/create/1' : 
            typeof props.variant === 'string' && props.variant.length > 17 && props.variant.length < 23 ? 
            '/league/join/' + props.variant :
            '/dashboard'; 

    const handleToggleShowPassword = () => {
        setShowPassword(!showPassword)
    }
    
    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };
    
    const handleEmailUpdate = (newVal) => {
        const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(newVal)
        setEmail({ valid: isValid, value: newVal })
    }
    
    const handlePasswordUpdate = (newVal) => {
    
        const isValid = newVal.length >= 8 && newVal.length <= 30 && // Password length
                        /[a-z]/g.test(newVal) && // lowerCase
                        /[A-Z]/g.test(newVal) && // uperCase
                        /[0-9]/g.test(newVal) // number
    
        setPassword({ valid: isValid, value: newVal })
    
    }

    const _handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        handleSubmit()
      }
    }

    const initializeAndNavigate = (initUser, leagActive, pred, predAnswer) => {

      getLeaguesByUID(initUser.uid) // pull leagues for user
      .then((leagues) => {

        let l = Boolean(leagues) && leagues.length > 0 ? leagues[0] : null

        dispatch({ type: "INIT_USER", payload: initUser });
        dispatch({ type: "INIT_LEAGUES", payload: leagues });
        dispatch({ type: "CHANGE_LEAGUEACTIVE", payload: l }); // asign active league
        dispatch({ type: "CHANGE_RANKEDLIST", payload: [] }); // update RankedList
        dispatch({ type: "LOAD_PREDICTION", payload: pred});
        dispatch({ type: "LOAD_PREDICTIONANSWER", payload: predAnswer});
        setLoading(false)
        navigate(path) // navigate to dashboard or create league

      }).catch((err) => { console.log("errLSx2", err); setLoading(false) })

    }

    const createUserOrLogin = (user) => {
      getUserByUID(user.uid)
      .then((resU1) => {
        if(!Boolean(resU1)) { // user is not found
          createUser(user) // proceed to create
          .then((resU2) => { // once created, initialize and navigate

            // todo - pull the active league
            initializeAndNavigate(resU2, 'leag1', [], [])

          }).catch((err) => console.log("err1x", err))

        } else { // user is found - initialize and navigate
          // todo - pull the active league
          getPredictionByUID(resU1.uid)
          .then((p) => {
            let pred = Boolean(p) && Boolean(p.prediction) ? p.prediction : []
            getPredictionAnswer()
            .then((pa) => {
              let predans = Boolean(pa) && Boolean(pa.prediction) ? pa.prediction : []
              initializeAndNavigate(resU1, 'leag1', pred, predans)
            })
          }).catch((err) => { console.log("err3x", err); setLoading(false) })
        }
      }).catch((err) => { console.log("err2x", err); setLoading(false) })
    }
    
    const loginClick = (provider) => {
      setLoading(true)
  
      if(['google'].includes(provider)){
        signInWithPopup(auth, providerGoogle)
        .then((result) => {
          // This gives you a Google Access Token
          
          const user = { 
            uid: result.user.uid,
            email: result.user.email,
            displayName: result.user.displayName,
            nickName: Boolean(result.user) && Boolean(result.user.nickName) ?
              result.user.nickName : null,
            photoURL: result.user.photoURL,
            creationDate: result.user.metadata.creationTime,
          }
  
          createUserOrLogin(user)
  
        }).catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log("error", errorCode, errorMessage)
          setLoading(false);
          // TODO: Error snackbar  
        })
      }
    }

    const handleSubmit = () => {

      setLoading(true);

      if(!email.valid) {
        dispatch({ type: "NEW_SNACKBAR", payload: "Please provide a valid e-mail address." })
        setLoading(false);
      } else if(!password.valid && !forgotPassword && !['step1'].includes(settingPassword)) {
        dispatch({ type: "NEW_SNACKBAR", payload: "Please provide a valid password." })
        setLoading(false);
      } 
      /*else if(
        forgotPassword || // Asking to reset password
        ['step1'].includes(settingPassword) || // Asking to verify email before creating a new password
        ['step2'].includes(settingPassword) // Creating a new password
      ) {
          axios.post(state.settings.api + "auth/createpassword", { // Resetting your password, sending link to user
            un: email.value,
            createString: ['step1', 'step2'].includes(settingPassword) ? createstring : null,
            isReset: ['step1', 'step2'].includes(settingPassword) ? false : true,
            newPw: ['step2'].includes(settingPassword) ? password.value : null,
          }).then((res) => {
    
            if(['step1'].includes(settingPassword)) { // Your email was verified succesfully
    
              setSettingPassword('step2');
              dispatch({ type: "NEW_SNACKBAR", payload: "Your email was verified succesfully" })
              setLoading(false);
    
            } else if(['step2'].includes(settingPassword)) { // Your email was verified succesfully
    
              setSettingPassword(null);
              setShowPassword(false)
              setPassword({valid: false, value: ''})          
              dispatch({ type: "NEW_SNACKBAR", payload: "New password created, continue to login" })
              setLoading(false);
    
            } else { // Step 0: You've reset your password to a createString
              setEmail({valid: false, value: ''})
              dispatch({ type: "NEW_SNACKBAR", payload: "Password reset completed, please check your inbox for instructions" })
              setLoading(false);
              setForgotPassword(false)
            }
    
          }).catch((err) => { dispatch({ type: "NEW_SNACKBAR", payload: "Password reset completed, please check your inbox for instructions" }); setLoading(false); })
    
      }*/ else { // Attempt Signing In/Up
  
        // GOGO
        createUserWithEmailAndPassword(auth, email.value, password.value)
        .then((userCredential) => { // newly created user
          const uc = userCredential.user;

          const user = { 
            uid: uc.uid,
            email: uc.email,
            displayName: uc.displayName, // will not exist
            nickName: null,
            photoURL: uc.photoURL, // will not exist
            creationDate: uc.metadata.creationTime,
          }

          createUserOrLogin(user)

        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log("error", errorCode, errorMessage)

          if(error.code === 'auth/email-already-in-use') {
            signInWithEmailAndPassword(auth, email.value, password.value)
            .then((uc) => { // Signed in 

              const user = { 
                uid: uc.user.uid,
                email: uc.user.email,
                displayName: uc.user.displayName,
                nickName: Boolean(uc.user) && Boolean(uc.user.nickName) ?
                            uc.user.nickNam : null,
                photoURL: uc.user.photoURL,
                creationDate: uc.user.metadata.creationTime,
              }
              createUserOrLogin(user)

            })
            .catch((error) => {
              const errorCode = error.code;
              const errorMessage = error.message;
              console.log("unable to login", errorCode, errorMessage)

              dispatch({ type: "NEW_SNACKBAR", payload: "Unable to sign " + (signingUp ? "up," : "in,") + " please try again." })
              setLoading(false);
              // TODO: Error snackbar - unable to login
            });
          } else {
            setLoading(false);
            // TODO: Error snackbar  - trying to signup/login but not possible
          }
        });



        /*
  
        axios.post(state.settings.api + "auth/login", {
          un: email.value, 
          pw: password.value,
        }).then((res) => { // TODO: limit frequency of login
  
          if(res.data !== undefined && res.data.success && res.data.data !== undefined && res.data.data !== null &&
          res.data.data.org !== undefined && res.data.data.org._id !== undefined &&
          res.data.data.user !== undefined && res.data.data.user._id !== undefined && res.data.data.user.email !== undefined) {
  
            initializeUser(dispatch, res.data.data)
            navigate(path)
            setLoading(false);
          }
  
        }).catch((err) => { dispatch({ type: "NEW_SNACKBAR", payload: "Authorization not successful" }); setLoading(false); })
        */
      }
    
    }
    

  return (
   
    <Grid container direction="column" justifyContent="center" alignItems="center">
          
            {loading ? 
            <Grid item container direction="column" alignItems="center" sx={{mb:5}}>
                <Grid item>
                    <CircularProgressCP />
                </Grid>
            </Grid>
            :
            <Grid item container direction="column" alignItems="center" sx={{mb:2}}>
              <Grid item>
                <Typography variant="h4" align="center"
                sx={{mb: ['step2'].includes(settingPassword) ? '20px' : '30px'}}>
                  {settingPassword !== null ?

                    "Create password: " + (['step1'].includes(settingPassword) ? "Provide email" : "New Password" ) :
                  forgotPassword ? 
                    "Reset password" :              
                    <>
                    Sign {signingUp ? "up" : "in"}<span style={{color: theme.palette.primary.main}}>.</span>
                    </>}
                </Typography>

                {// Indication of new Password and whether it matches criteria
                ['step2'].includes(settingPassword) ?
                <Typography color="textSecondary" variant="subtitle2" align="center" sx={{mb: 3}}>
                  <span style={password.value.length >= 8 && password.value.length <= 30 ? { color: theme.palette.success.main } : {}}>
                    8-30 characters
                  </span>&nbsp;&nbsp;+&nbsp;&nbsp;
                  <span style={/[A-Z]/g.test(password.value) ? { color: theme.palette.success.main } : {}}>
                    Uppercase
                  </span>&nbsp;&nbsp;+&nbsp;&nbsp;
                  <span style={/[a-z]/g.test(password.value) ? { color: theme.palette.success.main } : {}}>
                    Lowercase
                  </span>&nbsp;&nbsp;+&nbsp;&nbsp;
                  <span style={/[0-9]/g.test(password.value) ? { color: theme.palette.success.main } : {}}>
                    Number
                  </span>
                </Typography>
                :''}
              </Grid>
              <Grid item container direction="row" justifyContent="center" 
              sx={styles.resizeBox}>
                <Button onClick={e => loginClick('google')}
                variant="outlined" sx={{color: theme.palette.grey[800], fontWeight: '600',fontSize: '16px',
                borderRadius:'25px', border: '1px solid' + theme.palette.grey[400], margin: '5px',
                backgroundColor: theme.palette.primary.contrastText}}>
                <Avatar style={styles.avIcon} alt={"Google"} src={google} />
                Google
                </Button>
                <Button variant="outlined" sx={{color: theme.palette.grey[800], fontWeight: '600',fontSize: '16px',
                borderRadius:'25px', border: '1px solid' + theme.palette.grey[400], margin: '5px',
                backgroundColor: theme.palette.primary.contrastText}}>
                <Avatar style={styles.avIcon} alt={"Google"} src={facebook} />
                Facebook
                </Button>
                <Button variant="outlined" sx={{color: theme.palette.grey[800], fontWeight: '600',fontSize: '16px',
                borderRadius:'25px', border: '1px solid' + theme.palette.grey[400], margin: '5px',
                backgroundColor: theme.palette.primary.contrastText}}>
                <Avatar style={styles.avIconApple} alt={"Google"} src={apple} />
                Apple
                </Button>
              </Grid>

              {
              /*email.valid ? faCheckCircle : */
              /*email.valid ? theme.palette.success.main : */
              /*password.valid ? faCheckCircle : */
              /*password.valid ? theme.palette.success.main : */
              }
              <Grid item container direction="row" justifyContent="center" 
              sx={styles.resizeBox}>
                <Typography sx={{fontSize:'13px'}}>or sign {signingUp ? "up" : "in"} with:</Typography>
              </Grid>

              <Grid item sx={['step2'].includes(settingPassword) ? styles.hiddenBox : styles.resizeBox}>
                <TextField
                //autoFocus
                fullWidth
                variant="outlined"
                id="email"
                placeholder={(signingUp ? "Create" : "Your") + " username..."}
                label="Email Address"
                name="email"
                autoComplete="email"
                value={email.value}
                onChange={e => handleEmailUpdate(e.target.value.toLowerCase())}
                onKeyDown={_handleKeyDown}
                InputProps={{
                  startAdornment: (
                  <InputAdornment position="start">
                      <FontAwesomeIcon 
                      icon={faEnvelope} 
                      color={theme.palette.primary.main} />
                  </InputAdornment>
                  ),
                }}
                />  
              </Grid>
              <Grid item sx={forgotPassword || settingPassword === "step1" ? styles.hiddenBox : styles.resizeBox}>
                <TextField
                fullWidth
                variant="outlined"
                name="password"
                label="Password"
                type={showPassword ? 'text' : 'password'}
                id="password"
                placeholder={(signingUp ? "Create" : "Your") + " password..."}
                autoComplete="current-password"
                value={password.value}
                onChange={e => handlePasswordUpdate(e.target.value)}
                onKeyDown={_handleKeyDown}
                InputProps={{
                  startAdornment: (
                  <InputAdornment position="start">
                      <FontAwesomeIcon 
                      icon={faKey} 
                      color={theme.palette.primary.main} />
                  </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={e => handleToggleShowPassword()}
                        onMouseDown={handleMouseDownPassword}
                        style={{fontSize: '16px', padding: '7px 6px 7px 6px'}}
                      >
                        {showPassword ? <FontAwesomeIcon icon={faEye} /> : <FontAwesomeIcon icon={faEyeSlash} />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              </Grid>
              <Grid item sx={styles.resizeBox}>
                <Button
                onClick={handleSubmit}
                type="submit"
                disableElevation
                variant="contained"
                fullWidth
                disabled={loading}
                style={{padding: '5px 15px', fontWeight: '600', fontSize: '17px', marginBottom: '5px'}}>
                {loading ?
                <>Submitting...&nbsp;&nbsp;<CircularProgress size={15} /></>
                :
                signingUp ?
                "Sign up" : "Sign in"}
              </Button>
              </Grid>
              <Grid item container direction="row" justifyContent="center" 
              sx={styles.resizeBox}>
                <Button variant="contained" color="secondary"
                sx={{fontSize:'13px'}}>Forgot Password?</Button>&nbsp;&nbsp;
                <Button variant="contained" color="secondary"
                sx={{fontSize:'13px'}} onClick={e => setSigningUp(!signingUp)}>
                  {signingUp ? "Sign in instead" : "Create account"}</Button>
              </Grid>
              
              
            </Grid>
            }

    </Grid>

  );
}